export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/task-calendar/:pageId',
        component: () => import('@/views/page/company/admin/task-calendar/TaskCalendar.vue'),
        name: 'task-calendar',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/task-management/:pageId',
        component: () => import('@/views/page/company/admin/task-management/List.vue'),
        name: 'task-management',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/open-deal/:pageId',
        component: () => import('@/views/page/company/admin/sales-pipeline/OpenDeal.vue'),
        name: 'open-deal',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/list/:pageId',
        component: () => import('@/views/page/company/admin/sales-pipeline/SalePipeline.vue'),
        name: 'sale-pipeline-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/open-deal/:salePipelineId/:pageId/edit',
        component: () => import('@/views/page/company/admin/sales-pipeline/OpenDeal.vue'),
        name: 'edit-deal',
        meta: {
            requiresAuth: true
        }
    },
]
